import React, {useContext} from 'react';
import {LocalizationContext} from '@homeaway/react-localization-components';

import {useSelector} from 'react-redux';

import {SiteHeader} from '@homeaway/react-site-header';
import SiteFooter from '@homeaway/react-site-footer/lib/transpiled/components/SiteFooter';

import Help from '../Help';
import Contact from '../Contact';

const PageContainer = (props) => {
    const siteContext = useContext(LocalizationContext);
    const header = useSelector((state) => state.header);
    const footer = useSelector((state) => state.footer);

    const {
        name,
        fullLocale,
        locale,
        currencyCode,
        currency,
        theme
    } = siteContext;
    return (
        <>
            <SiteHeader
                {...{
                    isInverse: false,
                    siteName: name,
                    ...header,
                    fullLocale,
                    locale,
                    currencyCode,
                    currency,
                    theme
                }}
            />
            <Help {...props} />
            <Contact />
            <SiteFooter {...{data: footer, site: name}} />
        </>
    );
};

export default PageContainer;
